﻿<template>
  <section
    v-if="contentModel && vueModel"
    class="quick-quote-main"
    data-page-type="no-header"
    data-test-component="quickQuoteFlow"
  >
    <page-spinner :spinner-url-list="spinnerUrlList" />

    <div id="quickQuoteflow" data-page-type="flow">
      <!-- Sitecore Placeholder "phRightDektopTopMobile" -->
      <slot name="topmobile" />
      <div id="mainView" class="quick-quote__columns flow__body container row">
        <div
          class="quick-quote__left-column small-12 medium-12 large-6"
          :class="{ 'two-columns-page-layout--bottom-padding': innerPadding }"
        >
          <Form as="div" v-slot="{ errors }" ref="quickQuoteFlow">
            <!-- <keep-alive> -->
            <transition name="fade" mode="out-in">
              <component
                :is="currentTemplate"
                :key="index"
                :vue-model="vueModel"
                :step-model="stepModel"
                :content-model="contentModel"
                :name="'main-view'"
                :disable-next="disableNext"
                :is-qq-error-modal-shown="showQuickQuoteModal"
                @next="next"
                @disable-next-button="disableNextButton"
                @set-hide-next-button="setHideNextButton"
                @call-marketing-box-api="callMarketingBoxApi"
                @update-personal-information="updatePersonalInformationForTagManager"
                @update-covers="updateCoversForTagManager"
                @api-error="setApiErrorData"
                :errors="errors"
              />
            </transition>
            <!-- </keep-alive> -->
          </Form>

          <div v-if="isNewAccident && index === 1" class="special-conditions-link-modal">
            <base-info-link-modal
              :link-label="contentModel.InfoLinkModalSpecialConditions.LinkLabel"
              :title="contentModel.InfoLinkModalSpecialConditions.Title"
              :content="contentModel.InfoLinkModalSpecialConditions.Content"
              :button-label="contentModel.InfoLinkModalSpecialConditions.ButtonLabel"
            />
            <hr />
          </div>

          <div v-cloak class="row push-down">
            <div class="columns">
              <button
                class="button secondary large"
                :class="{ hide: index === 0 }"
                data-test="quickquote-back-button"
                @click="updateCurrentStepIndex(index - 1)"
                v-html="contentModel.SharedContent.LabelButtonPrevious"
              />
            </div>
            <div v-if="index !== 0" class="columns">
              <button
                class="button large show-for-large"
                :class="{ hide: index === 0 }"
                data-test="quick-quote-calculate-price-button"
                @click="
                  addToBasket(contentModel.SharedContent.LinkStepTwoSuccessRedirectUrlLinkModel.Url)
                "
                v-html="contentModel.SharedContent.LabelButtonAddtoBasket"
              />
            </div>
            <div v-if="index !== 1" class="columns">
              <button
                class="button"
                :class="{ hide: index === 1 || hideNext }"
                :disabled="disableNext"
                data-test="quickquote-button-next"
                @click="next"
                v-html="contentModel.SharedContent.LabelButtonNext"
              />
              <div
                v-if="disableNext"
                class="info-box is-open"
                :class="{ hide: index === 1 || hideNext }"
                data-test="quickquote-next-info-box"
              >
                <p>
                  <span v-html="contentModel.SharedContent.LabelModalContactContent" />
                  <strong v-html="contentModel.SharedContent.LabelModalContactTitle" /><br />
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          data-test-two-columns-page-layout-right
          class="small-12 medium-12 large-5 large-offset-1"
        >
          <price-panel
            v-if="index != 0"
            data-test-basket-price-list
            :headline="contentModel.SharedContent.LabelTotalPrice"
            :total-price-label="contentModel.SharedContent.LabelTotalPrice"
            :per-year-label="contentModel.SharedContent.LabelPrYear"
            :total-price="totalPrice"
            :actions-class="
              !contentModel.SharedFields.ShouldShowSendOfferButton
                ? 'quick-quote__price-list-actions--hide'
                : undefined
            "
          >
            <template #actions>
              <div
              
                class="quick-quote__price-list-actions flex-container flex-dir-row"
                :class="{
                  'quick-quote__price-list-actions--margin':
                    contentModel.SharedFields.ShouldShowSendOfferButton
                }"
              >
                <button
                  v-if="contentModel.SharedFields.ShouldShowSendOfferButton"
                  class="button large secondary iconbutton"
                  @click="
                    dispatchSendOfferButtonClick();
                    addToBasket(contentModel.SharedFields.SendOfferLink.Url);
                  "
                >
                  <span class="icon icon-heart" />
                  <span v-html="contentModel.SharedFields.SendOfferLink.Text" />
                </button>
                <button
                  class="button large hide-for-large"
                  :class="{ hide: index === 0 }"
                  data-test="quick-quote-calculate-price-button-mobile"
                  @click="
                    addToBasket(contentModel.SharedContent.LinkStepTwoSuccessRedirectUrlLinkModel.Url)
                  "
                  v-html="contentModel.SharedContent.LabelButtonAddtoBasket"
                />
              </div>
            </template>
          </price-panel>

          <!-- Sitecore Placeholder "phRightDektopTopMobile" -->
          <div class="quick-quote__campaign-box--desktop">
            <slot name="rightcolumn" />
          </div>

          <div class="row">
            <div class="small-12 medium-12 large-10 large-offset-2 columns">
              <div v-if="vueModel.PolicyCacheId">
                <marketing-box :id="vueModel.PolicyCacheId" />
              </div>
            </div>
            <div v-if="contentModel.SharedContent.PersonalAssistanceId" class="small-12 columns">
              <personal-assistance :data-source="contentModel.SharedContent.PersonalAssistanceId" />
            </div>
          </div>
        </div>
      </div>

      <quick-quote-error-modal
        :show-modal="showQuickQuoteModal"
        :title="contentModel.SharedContent.LabelModalContactTitle"
        :show-quick-quote-rule-verification-error="showQuickQuoteRuleVerificationError"
        :show-quick-quote-modal-error-validation="showQuickQuoteModalErrorValidation"
        :content="contentModel.SharedContent.LabelModalContactContent"
        :rule-verification-text="RuleVerificationText"
        :label-button-close="contentModel.SharedContent.LabelModalContactButtonClose"
        :call-me-datasource="contentModel.SharedContent.CallMeFormDatasource"
        :api-response-error="apiResponseError"
        @hide-quick-quote-error-modal="resetQuickQuoteErrorModal()"
        @api-error="setApiErrorData"
      />
    </div>
  </section>
</template>

<script>
import QuickQuoteMixin from './QuickQuoteMixin.vue';
import QuickQuoteRuleEngineMixin from './QuickQuoteRuleEngineMixin.vue';
import QuickQuoteErrorModal from './QuickQuoteErrorModal.vue';
import PersonalAssistance from './PersonalAssistance/PersonalAssistance.vue';
import { Form } from 'vee-validate';
import ValidatePropsMixin from '../ValidatePropsMixin.vue';
import { hasProperty } from '@/common/Util/utility.js';
import PricePanel from '@/components/Feature/Basket/PricePanel.vue';
import TwoColumnsPageLayout from '@/components/UI/TwoColumnsPageLayout.vue';
import FlowBasket from '@/common/FlowBasket.vue';
import TrustPilot from '@/components/UI/TrustPilot.vue';
import MarketingBox from '@/components/UI/MarketingBox.vue';
// import vSelect from '@/components/UI/VueSelect.vue';
import Utility from '@/common/UtilityFunctions.js';
// 
import BaseInfoLinkModal from '@/components/Forms/BaseInfoLinkModal/BaseInfoLinkModal.vue';
import axios from 'axios';

import AccidentQuickQuote from './AccidentQuickQuote.vue';
import CarQuickQuote from './CarQuickQuote.vue';
import ContentQuickQuote from './ContentQuickQuote.vue';
import ExtendedTravelQuickQuote from './ExtendedTravelQuickQuote.vue';
import PetQuickQuote from './PetQuickQuote.vue';
import HouseQuickQuote1000079 from './HouseQuickQuote1000079.vue';
import HealthQuickQuote from './HealthQuickQuote.vue';
import Coverage from './Coverage.vue';
import VacationHomeQuickQuote from './VacationHomeQuickQuote.vue';
import PageSpinner from '@/components/UI/PageSpinner.vue';
import ProgressBar from '@/components/UI/ProgressBar.vue';

// const AccidentQuickQuote = () =>
//   import(/* webpackChunkName: "Accident"  */ './AccidentQuickQuote.vue');
// const CarQuickQuote = () => import(/* webpackChunkName: "Car"  */ './CarQuickQuote.vue');
// const ContentQuickQuote = () =>
//   import(/* webpackChunkName: "Content"  */ './ContentQuickQuote.vue');
// const ExtendedTravelQuickQuote = () =>
//   import(/* webpackChunkName: "ExtendedTravel"  */ './ExtendedTravelQuickQuote.vue');
// const PetQuickQuoteVue = () => import(/* webpackChunkName: "Pet"  */ './PetQuickQuote.vue');
// const HouseQuickQuote1000079 = () =>
//   import(/* webpackChunkName: "House1000079"  */ './HouseQuickQuote1000079.vue');
// const HealthQuickQuote = () => import('./HealthQuickQuote.vue');
// const Coverage = () => import(/* webpackChunkName: "Coverage" */ './Coverage.vue');
// const VacationHomeQuickQuote = () =>
//   import(/* webpackChunkName: "VacationHome"  */ './VacationHomeQuickQuote.vue');

// Vue.component('VSelect', vSelect);
// Vue.component('VModal', Modal);

export default {
  name: 'QuickQuoteFlow',
  components: {
    Form,
    ProgressBar,
    PageSpinner,
    'quick-quote-accident-template': AccidentQuickQuote,
    'quick-quote-car-template': CarQuickQuote,
    'quick-quote-content-template': ContentQuickQuote,
    'quick-quote-extended-travel-template': ExtendedTravelQuickQuote,
    'quick-quote-house-template-1000079': HouseQuickQuote1000079,
    'quick-quote-pet-template': PetQuickQuote,
    'quick-quote-vacation-home-template': VacationHomeQuickQuote,
    'quick-quote-health-template': HealthQuickQuote,
    'coverage-template': Coverage,
    FlowBasket,
    MarketingBox,
    PersonalAssistance,
    TrustPilot,
    PricePanel,
    TwoColumnsPageLayout,
    QuickQuoteErrorModal,
    BaseInfoLinkModal
  },
  mixins: [ValidatePropsMixin, QuickQuoteMixin, QuickQuoteRuleEngineMixin],
  props: {
    initialContentModel: {
      type: Object,
      default() {
        return {};
      }
    },
    initialVueModel: {
      type: Object,
      default() {
        return {};
      }
    },
    innerPadding: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      vueModel: null,
      contentModel: null,
      index: 0,
      isIndicativePriceText: false,
      name: 'quickQuoteFlow',
      showQuickQuoteModal: false,
      showQuickQuoteModalErrorValidation: false,
      showQuickQuoteRuleVerificationError: false,
      loading: false,
      stepModel: {},
      disableNext: false,
      hideNext: false,
      personalInformationForTagManager: {},
      coversForTagManager: {},
      coverModel: null,
      resetGroupCover: false
    };
  },
  computed: {
    currentTemplate() {
      if (this.index === 0) {
        switch (this.vueModel.ProductTypeName) {
          case 'Personal_Accident':
            return 'quick-quote-accident-template';
          case 'Content':
            return 'quick-quote-content-template';
          case 'Car':
            return 'quick-quote-car-template';
          case 'ExtendedTravel':
            return 'quick-quote-extended-travel-template';
          case 'House':
            return 'quick-quote-house-template-1000079';
          case 'Pet':
            return 'quick-quote-pet-template';
          case 'Vacation_Home':
            return 'quick-quote-vacation-home-template';
          case 'Health':
            return 'quick-quote-health-template';
          case 'Extended_Travel':
            return 'quick-quote-extended-travel-template';
          // default:
          // TODO: What is the default?
          // return this.vueModel.Proposal.Step1Component;
        }
      }
      if (this.index === 1) {
        return 'coverage-template';
      }
      // TODO: What happens if this.index !== 1 || 0
      return '';
    },
    currentModel() {
      return this.vueModel;
    },
    totalPrice() {
      return this.vueModel.Coverage.YearlyPrice || '';
    },
    spinnerUrlList() {
      return [
        Utility.constants().API.quick_quote_flow_save + this.vueModel.ProductType + '/save',
        Utility.constants().API.quick_quote_flow_save + this.vueModel.ProductType + '/asset/update',
        Utility.constants().API.quickquote_update_cover,
        Utility.constants().API.quickquote_changegroupedcover,
        Utility.constants().API.quickquote_add_cover,
        Utility.constants().API.quickquote_remove_cover,
        Utility.constants().API.quickquote_readyforbasket
      ];
    },
    isNewAccident() {
      if (this.vueModel.ProductTypeName === 'Personal_Accident') {
        return true;
      }
      return false;
    },
    changedToYearZero() {
      return (
        this.vueModel.TemplateModel.AgeChild === '0' && this.vueModel.Coverage.YearlyPrice !== 0
      );
    },
    returnFromYearUpChildAccident() {
      return this.vueModel.ProductType === 1000007 && this.vueModel.TemplateModel.AgeChild > '0';
    }
  },
  watch: {
    currentStep: function (val) {
      this.callMarketingBoxApi(val);
    }
  },
  created() {},
  mounted() {
    this.contentModel = this.initialContentModel;
    this.vueModel = this.initialVueModel;

    if (!this.vueModel.Coverage) {
      this.vueModel.Coverage = {
        YearlyPrice: 0
      };
    }

    // this.$on('updateCovers', this.updateCovers);
    // this.$on('stepModelProp', this.setStepModelProp);

    // this.$on('showQuickQuoteModalErrorValidation', () => {
    //   this.showQuickQuoteModalErrorValidation = true;
    //   this.showQuickQuoteModal = true;
    // });
    // this.$on('showStdErrorModal', () => {
    //   this.showQuickQuoteModalErrorValidation = false;
    //   this.showQuickQuoteModal = true;
    // });
  },
  methods: {
    decodeHtml: Utility.decodeHtml,
    next() {
      this.$refs.quickQuoteFlow.validate().then((result) => {
        if (result.valid && this.index === 0) {
          this.loading = true;
          if (this.changedToYearZero && this.resetGroupCover) {
            axios
              .post(Utility.constants().API.quickquote_update_cover, this.coverModel)
              .then(() => {
                this.nextSaveQuickQuote();
              })
              .catch(() => {
                Utility.logError(err, this);
                this.showErrorModal();
              });
          } else {
            this.nextSaveQuickQuote();
          }
        } else {
          this.scrollToFirstError();
        }
      });
    },
    addToBasket(redirectLink) {
      const model = {
        PolicyCacheId: this.vueModel.PolicyCacheId
      };

      // If we have any rule-verification pending show it now
      if (this.verifyBlockingRules()) {
        return;
      }

      const vm = this;

      this.postQuickQuoteCreate(model)
        .then((resp) => {
          const responseJson = resp.data;
          if (!responseJson.IsReadyForBasket) {
            return false;
          }
          Utility.pushToTagManager(this.coversForTagManager);
          vm.$store.dispatch('Events/register', {
            event: 'product-add-to-cart',
            id: 'ecommerce',
            vm
          });
          window.location.assign(redirectLink);
        })
        .catch(() => {
          // TODO: implement error handling
          this.showQuickQuoteModal = true;
          Utility.pushToTagManager({
            event: 'track-event',
            eventCategory:
              Utility.getDanishtypeName(this.vueModel.ProductTypeName) + ' prisberegner',
            eventAction: '02 vælg dækning error',
            eventLabel: this.contentModel.SharedContent.LabelModalContactContent,
            eventValue: '0',
            eventNoninteraction: true
          });
        });
    },
    postQuickQuoteCreate(data) {
      return axios.post(Utility.constants().API.quickquote_readyforbasket, data, this.config);
    },
    showQuickQuoteModalVerificationIssue() {
      this.showQuickQuoteRuleVerificationError = true;
      this.showQuickQuoteModal = true;
    },
    showQuickQuoteModalError() {
      this.showQuickQuoteModalErrorValidation = true;
      this.showQuickQuoteModal = true;
    },
    goToCovers() {
      this.updateCurrentStepIndex(1);
      axios.post(
        Utility.constants().API.quickquote_visitstep2,
        {
          policyCacheId: this.vueModel.PolicyCacheId
        },
        this.config
      );
    },
    updateCurrentStepIndex(index) {
      // when switching between steps make sure we mark the asset to be cleared.
      this.vueModel.TemplateModel.ShouldClearAsset = true;
      this.index = index;
      this.updateActiveStep(index + 1);
      if (index === 0 && this.returnFromYearUpChildAccident) {
        this.resetChildAccidentCoverModel(this.vueModel.Coverage.CoverSections[0].CoverElements[0]);
        this.resetGroupCover = true;
      } else if (index === 0 && this.vueModel.TemplateModel.AgeChild === '0') {
        this.resetGroupCover = false;
      }
    },
    setCovers(coverage) {
      this.vueModel.Coverage = coverage;
    },
    updateCovers(coverage) {
      this.setCovers(coverage);
      this.updateActiveVerificationIssues(coverage.ProductRuleVerificationErrors);
      this.verifyBlockingRules();
    },
    setStepModelProp(propName, propValue) {
      this.stepModel[propName] = propValue;
    },
    responseSuccess(response) {
      this.handleResponse(response, this.showQuickQuoteModalError, () => {
        this.showQuickQuoteModal = true;
      });
    },
    disableNextButton(val) {
      this.disableNext = val;
    },
    setHideNextButton(isHideNext) {
      this.hideNext = isHideNext;
    },
    updatePersonalInformationForTagManager(data) {
      this.personalInformationForTagManager = data;
    },
    updateCoversForTagManager(data) {
      this.coversForTagManager = data;
    },
    setIndicativePriceText(isIndicative) {
      this.isIndicativePriceText = isIndicative;
    },
    callMarketingBoxApi(step) {
      this.$store.dispatch('marketingBox/getData', step);
    },
    resetQuickQuoteErrorModal() {
      this.showQuickQuoteRuleVerificationError = false;
      this.showQuickQuoteModalErrorValidation = false;
      this.showQuickQuoteModal = false;
    },
    // Test af "Send beregning knap"
    dispatchSendOfferButtonClick() {
      this.$store.dispatch('Events/register', {
        event: 'basket-send-offer-qq-button-click',
        id: 'basketSendOffer',
        vm: {
          type: Utility.getDanishTypeName(this.vueModel.ProductTypeName)
        }
      });
    },
    resetChildAccidentCoverModel(cover) {
      this.coverModel = {
        PolicyCacheId: this.vueModel.PolicyCacheId,
        AmountUpdateType: cover.AmountUpdateType,
        AmountType: cover.AmountType,
        AmountRefId: 1200000,
        CoverCacheId: cover.Id
      };
    },
    nextSaveQuickQuote() {
      this.saveQuickQuoteData(
        (response) => {
          this.responseSuccess(response);
          Utility.pushToTagManager(this.personalInformationForTagManager);
          this.loading = false;
        },
        () => {
          this.showQuickQuoteModalErrorValidation = false;
          this.showQuickQuoteModal = true;
          Utility.pushToTagManager({
            event: 'track-event',
            eventCategory: this.getDanishProductTypeName + ' prisberegner',
            eventAction: '01 oplysninger error',
            eventLabel: '',
            eventValue: '0',
            eventNoninteraction: true
          });
        }
      );
    }
  }
};
</script>

<style lang="scss">
@import 'src/styles/all.scss';
.unselectable {
  user-select: none;
}

.quick-quote-main {
  padding-top: 0;
  padding-bottom: 0;
}

.quick-quote {
  &__campaign-box--desktop {
    @include breakpoint(large up) {
      margin-top: rem-calc(48);
    }
  }

  &__price-list-actions {
    @include breakpoint(medium down) {
      &--margin {
        > .button:not(:last-child) {
          margin-right: rem-calc(8);
        }
      }
    }

    @include breakpoint(large up) {
      &--hide {
        display: none;
      }
    }
  }

  &__left-column {
    padding-bottom: rem-calc(180);
    @include breakpoint(medium down) {
      padding-left: rem-calc(20);
      padding-right: rem-calc(20);
    }
  }

  &__columns {
    padding-top: rem-calc(60);
    padding-bottom: 0;

    @include breakpoint(medium down) {
      padding-right: 0;
      padding-left: 0;
    }
  }
}

.special-conditions-link-modal {
  margin-bottom: rem-calc(48);
}
</style>
